import React from 'react';
import PropTypes from 'prop-types';
import CreatePlugwrap from '../../components/CreatePlugwrap';
import { Table, Modal, Input, Button } from 'antd';
import { connect } from 'react-redux';
import './plugwrapThickness.css';
import plugwrapTableHeader from '../../model/PlugwrapTableHeader';
import Translation from '../../Translation';
import { utils } from '../../config';

/**
 * Class for showing existing plugwraps
 *
 * @class PlugwrapThickness 
 * @extends {React.Component}
 */
class PlugwrapThickness extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: [],
            columns: [],
            selectedRowKeys: [],
            currentThicknessVal: 0.042,
            currentPorosityVal: 0,
            visibleCreatePlugwrap: false,
            loading: true,
            selectButtonDisplay: 'displayInlineBlock',
            searchText: []
        };

        this.getThicknessValue = this.getThicknessValue.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.JSONToCSVConvertor = this.JSONToCSVConvertor.bind(this);
    }


    componentDidMount() {
        this.assignData(this.props);
        if (this.props.openingPlugwrapFromHeader) {
            this.setState({
                selectButtonDisplay: 'displayNone'
            });
        }
    }

    /**
     * filterDropdown function is for showing dropdown for each column in the tow items table.
     *
     * @param {Object} opts which is object, it will take selected row keys and user confirmation.
     * @memberof PlugwrapThickness
     */
    filterDropdown = (opts) => {
        let that = this;
        return (
            <div className="custom-filter-dropdown">
                <Input
                    ref={ele => that.searchInput = ele}
                    placeholder={utils.getTranslationText('lbl_search_name', 'Search name')}
                    value={opts.selectedKeys[0]}
                    onChange={e => opts.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={that.handleSearch(opts.selectedKeys, opts.confirm)}
                />
                <Button type="primary" onClick={that.handleSearch(opts.selectedKeys, opts.confirm)}><Translation labelName="lbl_search" defaultText="Search" /></Button>
                <Button onClick={that.handleReset(opts.clearFilters)}><Translation labelName="lbl_reset" defaultText="Reset" /></Button>
            </div>)
    }
    /**
    * onFilterDropdownVisibleChange function is for toggling the search input visibility.
    * 
    * @param {boolean} visible takes boolean as input
    * @memberof PlugwrapThickness
    */
    onFilterDropdownVisibleChange = (visible) => {
        let that = this;
        if (visible) {
            setTimeout(() => {
                that.searchInput.focus();
            });
        }
    }
    /**
     * tableRender function is for rendering of highlighted text.
     * 
     * @param {string} text which will take string as input
     * @memberof PlugwrapThickness
     */
    tableRender = (text) => {
        const { searchText } = this.state;
        return searchText ? (
            <span>
                {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === searchText.toLowerCase()
                        ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                ))}
            </span>
        ) : text;
    }
    /**
     * handleSearch function is for performing search on the table with selected row keys.
     *
     * @param {array} selectedKeys
     * @param {func} confirmhandler
     * @memberof PlugwrapThickness
     */
    handleSearch = (selectedKeys, confirmhandler) => () => {
        confirmhandler();
        this.setState({ searchText: selectedKeys[0] });
    }

    /**
     * handleReset function is for clearing searched fields on the table.
     *
     * @param {func} clearFilters
     *
     * @memberof PlugwrapThickness
     */
    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

     /**
     * assignData function is for assigning the plugwrap data from redux.
     * 
     * @param {object} nextProps
     * @memberof PlugwrapThickness
     */
    assignData=(nextProps) => {
        if(nextProps.plugwrapData) {
            let data = nextProps.plugwrapData;

            if (!Array.isArray(data) || (Array.isArray(data) && data.length === 0)) {
                this.setState({
                    loading: false
                })
                return;
            }
            
            let headers = Object.keys(data[0]).filter(item => {
                switch (item) {
                    case 'createdAt':
                    case 'updatedAt':
                    case 'recNumber':
                    case 'userId':
                        break;
                    default:
                        return item;
                }
                return !1;
            });

            let newData = data.map((obj) => {
                var Obj = {};
                headers.forEach(function (header) {
                    Obj[header] = obj[header];
                });
                return Obj;
            });

            this.setState({
                rows: newData,
                loading: false
            });
        }
    }
    /**
     * handleSelected function will return selected pluwrap thickness value
     *
     * @memberof PlugwrapThickness
     */
    handleSelect() {
        this.getThicknessValue(this.state.selectedRowKeys[0]);
        this.props.handlePlugwrapCancel(false);
    }
    /**
     * 
     *  handleCancel function will close the plugwrap window
     * @memberof PlugwrapThickness
     */
    handleCancel() {
        if (this.props.openingPlugwrapFromHeader) {
            this.props.showPlugwrapScreen(false);
        }
        else {
            this.props.handlePlugwrapCancel(false);
        }
    }

    /**
     *getThicknessValue function takes the selected id and filters it from the data 
     *depending upon the props it will return porosity value or thickness value
     * @param {string} plugwrapName
     * @memberof PlugwrapThickness
     */
    getThicknessValue(plugwrapName) {
        var data = this.state.rows;
        let result = data.find(element => element.id === plugwrapName);

        if (result && this.props.openingFromTipVent) {
            this.props.updatePorosityValue(result.corpor);
        }
        else {
            if (result) {
                this.props.updatePlugwrapValue(result.thick);
            }
            else {
                this.props.updatePlugwrapValue(this.state.currentThicknessVal);
            }
        }
    }
    /**
     *sets the value for the selected plugwrap
     * @param {object} selectedRowKeys
     * @memberof PlugwrapThickness
     */
    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    }

    /**
     *
     * handleCreatePlugwrapCancel closes the form for create plugwrap window
     * @memberof PlugwrapThickness
     */
    handleCreatePlugwrapCancel = () => {
        this.setState({
            visibleCreatePlugwrap: false
        });
    }
    /**
     *
     * showCreatePlugwrapModal opens the form for create plugwrap window
     * @memberof PlugwrapThickness
     */
    showCreatePlugwrapModal = () => {
        this.setState({
            visibleCreatePlugwrap: true
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.rowSelectionDisable) {
            this.setState({
                selectedRowKeys: null
            });
        }
        this.assignData(nextProps);
    }


    downloadFile = () => {
        this.JSONToCSVConvertor(this.state.rows, "Plugwrap Thickness Data");
    }

    JSONToCSVConvertor(JSONData, ReportTitle) {
        const finalObject = (input) => {
            let obj = {
                'Name': input.name,
                'Manufacturer': input.manufacturer,
                'CORESTA Porosity': input.corpor,
                'Wrap Type': input.wrapType,
                'Thickness': input.thick,
                'Weight': input.weight
            }

            return obj;

        }

        let allKeys = Object.keys(finalObject(JSONData[0]));
        let csvContent = [];
        let header = [];
        allKeys.forEach(function (y) {
            header.push(y);
        });
        csvContent.push(header.join('\t'));
        csvContent.push('\r\n');

        JSONData.map(function (data) {
            let output = finalObject(data);
            let plugwrapContent = [];
            for (const key of Object.keys(output)) {
                plugwrapContent.push(output[key]);
            }
            csvContent.push(plugwrapContent.join('\t'));
            csvContent.push('\r\n');
            return true;
        })

        if (csvContent.length === 0) {
            return;
        }


        //Generate a file name
        var fileName = "";
        //this will remove the blank-spaces from the title and replace it with an underscore
        fileName += ReportTitle.replace(/ /g, "_");

        //Initialize file format you want csv or xls
        var uri = 'data:text/tsv;charset=utf-8,' + escape(csvContent.join(''));

        let element = document.getElementById('selected-towitems-link');
        element.setAttribute('href', uri);
        element.setAttribute('download', fileName + '.tsv');
        setTimeout(function () {
            element.click();
        }, 1000);
    }

    render() {
        for (let i = 0; i < 4; i++) {
            if (i !== 2) {
                plugwrapTableHeader[i].filterDropdown = this.filterDropdown;
                plugwrapTableHeader[i].onFilterDropdownVisibleChange = this.onFilterDropdownVisibleChange;
                plugwrapTableHeader[i].tableRender = this.tableRender;
            }
        }
        const { rows, selectedRowKeys } = this.state;
        let rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            type: 'radio',
        };

        if (this.props.openingPlugwrapFromHeader) {
            rowSelection = null;
        }
        return (
            <div>
                <div className="plugwrap-container">
                    <Button type="primary" shape="circle" icon="download" className='download-plugwrap' size="small" onClick={(e) => this.downloadFile(e)} />
                    {/* <a href='/help/html/Plugwrap_Database.htm' target="_blank" title="Help" className="help-section">
                        <img
                            src="./images/help-inverse-black.svg"
                            alt="help"
                            className="help-icon" />
                    </a> */}
                    <h2><Translation labelName="title_select_plugwrap" defaultText="Select Plugwrap"/></h2>
                    <Table
                        dataSource={rows}
                        columns={plugwrapTableHeader}
                        rowKey={'id'}
                        rowSelection={rowSelection}
                        scroll={{ y: 300 }}
                        className="plugwrap-table"
                        loading={this.state.loading}
                        pagination={false}
                        bordered
                        size="small"
                    />
                    <span className={this.state.selectButtonDisplay}>
                        <button
                            value="select"
                            type="submit"
                            className="btn btn-default"
                            onClick={() => this.handleSelect()}><Translation labelName="btn_select" defaultText="SELECT"/></button>
                    </span>
                    <button
                        value="create"
                        type="submit"
                        className="btn btn-default"
                        onClick={this.showCreatePlugwrapModal}><Translation labelName="btn_create" defaultText="CREATE"/></button>
                </div>
                {this.state.visibleCreatePlugwrap &&
                    <Modal
                        visible={this.state.visibleCreatePlugwrap}
                        footer={null}
                        style={{ top: 20 }}
                        centered
                        onCancel={this.handleCreatePlugwrapCancel}
                        width={425}
                    >
                        <CreatePlugwrap
                            handleCreatePlugwrapCancel={this.handleCreatePlugwrapCancel}>
                        </CreatePlugwrap>
                    </Modal>}
            </div>
        );
    }
}

const mapStateToProps = ({ filtersState }) => ({
    plugwrapData: filtersState.plugwrapData
});

export default connect(mapStateToProps, null)(PlugwrapThickness);

PlugwrapThickness.propTypes = {
    updatePlugwrapValue: PropTypes.func,
    updatePorosityValue: PropTypes.func,
    rowSelectionDisable: PropTypes.bool,
    openingFromTipVent: PropTypes.bool,
    showPlugwrapScreen: PropTypes.func,
    handlePlugwrapCancel: PropTypes.func,
    isPlugwrapVisible: PropTypes.bool,
    openingPlugwrapFromHeader: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/PlugwrapThickness/index.js